import { render, staticRenderFns } from "./organizationManagement.vue?vue&type=template&id=f047130c&scoped=true&"
import script from "./organizationManagement.vue?vue&type=script&lang=js&"
export * from "./organizationManagement.vue?vue&type=script&lang=js&"
import style0 from "./organizationManagement.vue?vue&type=style&index=0&id=f047130c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f047130c",
  null
  
)

export default component.exports